import { RoutePath } from 'enums/Routes';
import PlaidLink from 'components/Verification/Steps/CheckingAccount/Plaid';

import { RouterType } from './types';

export const getAICoachRoutes = (): RouterType => ({
  [RoutePath.PlaidCheckingAccounts]: {
    component: PlaidLink,
    handleNext: ({ navigate }) => () => {
      navigate(RoutePath.FinancialDashboard);
    },
  },
});
